module.exports = __webpack_public_path__ + "static/media/error403.82bbc0d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/img/error/error403.png
// module id = 700
// module chunks = 8